<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    import Qs from 'qs'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import axios from 'axios'
    import download from '@/utils/download'

    let proposalStatus = {"0": "待审核", "1": "已审批", "2": "已取消"};
    let levelType = {"MIN":"迷你","STD":"标准","PLA":"铂金"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        methods: {
            checkbox(row) {
                this.ids = row.map(key => key.id).join(",");
                this.proposals = row.map(key => key.proposalStatus).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "update") {
                    this.$refs.childUpdate.open(row);
                }else if (clickName == "details") {
                    this.$refs.childUpdate.open(row);
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName  || window.$t('txmis.bt.query') == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                } else if (window.$t('txmis.bt.add') == clickName) {
                    this.$refs.childUpdate.open();
                } else if (window.$t('txmis.relationList.applyProposal') == clickName) {
                    //校验
                    if (!this.judge()) {
                        return;
                    }
                    this.dataChanage(URL.customerRelation.approvalProposal, {ids: this.ids}, res => {
                        if (res.code == 0) {
                            this.$message.success(window.$t('txmis.accountReward.applySuccess'));
                            this.$refs.childTable.defaultGetData(this.queryData);
                        } else {
                            this.$message.error(window.$t('txmis.accountReward.applyFail'));
                        }
                    });
                } else if (window.$t('txmis.relationList.cancelProposal') == clickName) {
                    //校验
                    if (!this.judge()) {
                        return;
                    }
                    this.dataChanage(URL.customerRelation.cancelProposal, {ids: this.ids}, res => {
                        if (res.code == 0) {
                            this.$message.success(window.$t('txmis.accountReward.applySuccess'));
                            this.$refs.childTable.defaultGetData(this.queryData);
                        } else {
                            this.$message.error(window.$t('txmis.accountReward.applyFail'));
                        }
                    });
                } else if (window.$t('txmis.bt.down') == clickName) {
                    //隐藏关键字段
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide: true});
                    download.exportExcel(URL.customerRelation.downloadProList, param, window.$t('txmis.relationList.customerRelationPro'));
                } else if (window.$t('txmis.bt.export') == clickName) {
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
                    download.exportExcel(URL.customerRelation.downloadProList, param, window.$t('txmis.relationList.customerRelationPro'));
                }
            },
            judge() {
                if (!this.proposals && this.proposals.length <= 0) {
                    this.$message({
                        message: window.$t('txmis.accountReward.choiceOne'),
                        type: 'warning'
                    });
                    return false;
                }
                if ((this.proposals.indexOf("1") != -1) || this.proposals.indexOf("2") != -1) {
                    this.$message({
                        message: window.$t('txmis.accountReward.notSatisfiable'),
                        type: 'warning'
                    });
                    return false;
                }
                return true;
            },
            /*新增或跟提交数据触发事件*/
            submit(model) {
                //根据是否包含id更新还是添加
                this.dataChanage(URL.customerRelation.edit, model, res => {
                    if (res.data.code == 0) {
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    } else {

                    }
                })
            },
            dataChanage(url, option, suc, fail) {
                this.axios.post(url, Qs.stringify(option || {})).then(res => {

                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data() {
            return {
                ids: "",
                proposals: "",
                queryData: {},
                /*新增或更新*/
                updateData: {
                    submit:'hidden',
                    cols: [
                        {title: 'id', field: 'id', hidden: true},
                        {title: window.$t('txmis.relationList.customerNum'), field: 'customerNum', disabled: true},
                        {title: window.$t('txmis.relationList.mobilePhone'), field: 'mobilePhone', disabled: true},
                        {title: window.$t('txmis.relationList.userName'), field: 'userName', disabled: true},
                        {title: window.$t('txmis.relationList.userLevel'), field: 'userLevel', type: 2, optionList: levelType, disabled: true},
                        {title: window.$t('txmis.relationList.createDate'), field: 'createDate', type: 5, disabled: true},
                        {title: window.$t('txmis.relationList.activeTime'), field: 'activeTime', type: 5, disabled: true},
                        {title: window.$t('txmis.relationList.newdirectPhone'), field: 'newdirectPhone', disabled: true},
                        {title: window.$t('txmis.relationList.remark'), field: 'remark', disabled: true},
                    ]
                },
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [


                        {title: window.$t('txmis.relationList.customerNumber'), field: 'customerNum'},
                        {title: window.$t('txmis.relationList.phone'), field: 'phone'},
                        {title: window.$t('txmis.relationList.beginDate'), field: 'beginDate', type: 5},
                        {title: window.$t('txmis.relationList.endDate'), field: 'endDate', type: 5},
                        {title: window.$t('txmis.tracker.activeStartTime'), field: 'activeStartTime',type:5},
                        {title: window.$t('txmis.tracker.activeEndTime'), field: 'activeEndTime',type:5},
                        {title: window.$t('txmis.relationList.proposalStatus'), field: 'proposalStatus', type: 2, optionList: proposalStatus},
                        {title: 'dataType', field: 'dataType', data: 1, hidden: true},
                        {click: window.$t('txmis.bt.query')},
                        {click: window.$t('txmis.bt.down')},
                        {click: window.$t('txmis.bt.export')},
                        {click: window.$t('txmis.relationList.applyProposal')},
                        {click: window.$t('txmis.relationList.cancelProposal')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.customerRelation.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {title: window.$t('txmis.relationList.proposalNo'), field: 'proposalNo',h5Click: "details"},
                        {
                            title: window.$t('txmis.relationList.proposalStatus'), field: 'proposalStatus', render: (data, full) => {
                                return proposalStatus[data] || "";
                            }
                        },
                        {title: window.$t('txmis.relationList.customerNum'), field: 'customerNum'},
                        {title: window.$t('txmis.relationList.mobilePhone'), field: 'mobilePhone'},
                        {title: window.$t('txmis.relationList.userName'), field: 'userName'},
                        {
                            title: window.$t('txmis.relationList.userLevel'), field: 'userLevel', render: (data, full) => {
                                return levelType[data] || "";
                            }
                        },
                        {title: window.$t('txmis.relationList.directNumber'), field: 'directNumber'},
                        {title: window.$t('txmis.relationList.directPhone'), field: 'directPhone'},
                        {title: window.$t('txmis.relationList.indirectNumber'), field: 'indirectNumber'},
                        {title: window.$t('txmis.relationList.indirectPhone'), field: 'indirectPhone'},
                        {title: window.$t('txmis.relationList.proposalUser'), field: 'proposalUser'},
                        {
                            title: window.$t('txmis.relationList.proposalDate'), field: 'proposalDate', render: (data, full) => {
                                return DateUtil.formatDate(data, "yyyy-MM-dd hh:mm:ss");
                            }
                        },
                        {title: window.$t('txmis.relationList.approvalUser'), field: 'approvalUser'},
                        {
                            title: window.$t('txmis.relationList.approvalDate'), field: 'approvalDate', render: (data, full) => {
                                return DateUtil.formatDate(data, "yyyy-MM-dd hh:mm:ss");
                            }
                        }
                    ]
                }
            }
        }
    }
</script>
